/**
 * accordion
 */

import $ from 'jquery';
import { gsap } from 'gsap';

// Module dependencies
import 'protons';

// Module template
import './_accordion.twig';
import './_accordion.css';

export const name = 'accordion';

export const defaults = {
  dummyClass: 'js-accordion-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { accordion = {} }) {
  // Find our component within the DOM
  const $accordion = $('.accordion', $context);
  // Bail if component does not exist
  if (!$accordion.length) {
    return;
  }
  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...accordion,
  };
  // An example of what could be done with this component
  $accordion.addClass(settings.dummyClass);
}

function accordionInit() {
  const list = gsap.utils.toArray('.accordion-item');

  list.forEach((accordion) => {
    let isOpen = false;

    const title = accordion.getElementsByClassName('accordion-item__title')[0];
    const icon = accordion.getElementsByClassName('accordion-item__icon')[0];
    const content = accordion.getElementsByClassName('accordion-item__content')[0];

    title.addEventListener('click', () => {
      isOpen = !isOpen;

      gsap.to(
        title,
        isOpen
          ? { color: '#42504B' }
          : { color: '#9AAAA5' }
      );
      gsap.to(content, { height: isOpen ? 'auto' : '0px' });
      gsap.to(icon, { rotate: isOpen ? 270 : 90, marginLeft: isOpen ? '2px' : '0px' });
    });
  });

}

function accordionMenuInit() {
  const list = gsap.utils.toArray('.accordion-item-menu');

  list.forEach((accordion) => {
    let isOpen = false;

    const title = accordion.getElementsByClassName('accordion-item__title-menu')[0];
    const icon = accordion.getElementsByClassName('accordion-item__icon')[0];
    const content = accordion.getElementsByClassName('accordion-item__content')[0];

    title.addEventListener('click', () => {
      isOpen = !isOpen;

      gsap.to(
        title,
        isOpen
          ? { color: '#ECEEF1' }
          : { color: '#6D7C77' }
      );
      gsap.to(content, { height: isOpen ? 'auto' : '0px' });
      gsap.to(icon, { rotate: isOpen ? 270 : 90, marginLeft: isOpen ? '2px' : '0px' });
    });

    // Open accordion on load
    // title.click();

  });

}

accordionInit();
accordionMenuInit();

export default enable;
